import { z } from 'zod';

export const permissions = ['TENANT_READ', 'TENANT_WRITE', 'INTEGRATION_READ', 'INTEGRATION_WRITE', 'USER_MANAGEMENT'] as const;

export const Permissions = z.enum([
  // This DEFAULT permission does not need to be defined in the permissions list in the database, but is put here for
  // consistency and ease-of-use.
  'DEFAULT',
  ...permissions,
]);

export type PermissionType = z.infer<typeof Permissions>;
